import { FC, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router'

import { LoadingSpinner } from '@/components'
import { ShiftExchangeDetailByMe, ShiftExchangeDetailForMe } from '@/containers'
import { trans } from '@/helpers/trans'
import { acceptShiftExchange, cancelShiftExchange, getShiftExchange } from '@/redux/exchanges/exchangesActions'
import { Reducers } from '@/redux/reducers'
import { useTypedDispatch as useLegacyTypedDispatch } from '@/redux/store'

export const ConnectedShiftExchangeDetail: FC = () => {
    const dispatch = useLegacyTypedDispatch()
    const navigate = useNavigate()
    const { currentUser, settings } = useSelector((state: Reducers) => state.userReducer)
    const { shiftExchange, loading } = useSelector((state: Reducers) => state.exchangesReducer)
    const { exchangeUuid = '' } = useParams<{ exchangeUuid: string }>()

    useEffect(() => {
        dispatch(getShiftExchange(exchangeUuid))
    }, [exchangeUuid])

    const onCancelShiftExchange = () => {
        dispatch(cancelShiftExchange(exchangeUuid, navigate))
    }

    const onDenyShiftExchange = () => {
        dispatch(cancelShiftExchange(exchangeUuid, navigate, true))
    }

    const onAcceptShiftExchange = () => {
        dispatch(acceptShiftExchange(exchangeUuid, navigate))
    }

    if ((loading && ! shiftExchange) || ! currentUser) {
        return <LoadingSpinner />
    }

    if (! shiftExchange) {
        return (
            <>
                {trans('pages.exchanges.exchangeNotFound')}
            </>
        )
    }

    const ownerId = shiftExchange.shiftPlanning1.user?.id

    if (ownerId && ownerId === currentUser?.id) {
        return (
            <ShiftExchangeDetailByMe
                loading={loading}
                settings={settings}
                onCancelShiftExchange={onCancelShiftExchange}
                exchange={shiftExchange}
            />
        )
    }

    return (
        <ShiftExchangeDetailForMe
            loading={loading}
            settings={settings}
            onDenyShiftExchange={onDenyShiftExchange}
            onAcceptShiftExchange={onAcceptShiftExchange}
            exchange={shiftExchange}
        />
    )
}
